import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
import _sfc_main$1 from "./control_string.vue.js";
import { createBlock, openBlock, renderSlot, unref, withCtx } from "vue";
//#region src/components/controls/control_base.vue
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcControlBase" }, {
	props: {
		value: {
			type: void 0,
			default: () => String()
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	emits: [VALUE_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(_sfc_main$1, {
				value: __props.value?.toString(),
				disabled: __props.disabled,
				"onUpdate:value": _cache[0] || (_cache[0] = (e) => emit(unref("update:value"), e))
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, ["value", "disabled"]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=control_base.vue.js.map